import { FloatButton, Modal } from 'antd';
import { useEffect, useState } from 'react';
import { getSalaryIncreaseApprovals } from '../service';
import SalaryIncreaseApproval from '../index';

const TeachersSalaryIncreaseFloatButton = ({ status }) => {
  const [visible, setVisible] = useState(false);
  const [count, setCount] = useState(0);
  useEffect(() => {
    getSalaryIncreaseApprovals({
      pageSize: 10,
      current: 1,
      approvalStatus: status,
    }).then((res) => {
      setCount(res.total);
    });
  }, [status]);

  const onFinish = () => {
    setCount(count - 1);
  };

  return (
    <>
      <FloatButton
        onClick={() => setVisible(true)}
        badge={{
          count: count,
          overflowCount: 999,
        }}
        style={{ right: 20, bottom: 100 }}
        tooltip="达到涨薪标准的老师"
      />
      <Modal
        title="达到涨薪标准的老师"
        open={visible}
        footer={null}
        onCancel={() => setVisible(false)}
        width={1000}
      >
        <SalaryIncreaseApproval status={status} onFinish={onFinish} />
      </Modal>
    </>
  );
};

export default TeachersSalaryIncreaseFloatButton;
